<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">Reflections On El Camino</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-3"><a href="#/text/ch003#acknowledgement">Acknowledgement</a></li>
<li id="toc-li-4"><a href="#/text/ch004#chapter-1-crossing-the-pyrénées">Chapter 1:  Crossing the Pyrénées</a></li>
<li id="toc-li-5"><a href="#/text/ch005#chapter-2-getting-started-going-west">Chapter 2:   Getting Started Going West</a></li>
<li id="toc-li-6"><a href="#/text/ch006#chapter-3-pamplona-without-the-bulls">Chapter 3:   Pamplona without the Bulls</a></li>
<li id="toc-li-7"><span href="#/text/ch007#chapter-4-alto-de-pardon-energy-or-environment" title="Link target outside of Sample">Chapter 4:   Alto De Pardon, Energy or Environment?</span></li>
<li id="toc-li-8"><span href="#/text/ch008#chapter-5-reflections-before-los-arcos" title="Link target outside of Sample">Chapter 5:   Reflections Before Los Arcos</span></li>
<li id="toc-li-9"><span href="#/text/ch009#chapter-6-la-rioja-land-of-red-wine" title="Link target outside of Sample">Chapter 6:   La Rioja, Land of Red Wine</span></li>
<li id="toc-li-10"><span href="#/text/ch010#chapter-7-cockerels-in-the-cathedral" title="Link target outside of Sample">Chapter 7:   Cockerels in the Cathedral</span></li>
<li id="toc-li-11"><span href="#/text/ch011#chapter-8-el-cid-in-burgos" title="Link target outside of Sample">Chapter 8:   El Cid in Burgos</span></li>
<li id="toc-li-12"><span href="#/text/ch012#chapter-9-upset-under-the-umbrellas" title="Link target outside of Sample">Chapter 9:   Upset Under the Umbrellas</span></li>
<li id="toc-li-13"><span href="#/text/ch013#chapter-10-mr-blue-in-mansilla-de-las-mulas" title="Link target outside of Sample">Chapter 10:   Mr Blue in Mansilla De Las Mulas</span></li>
<li id="toc-li-14"><span href="#/text/ch014#chapter-11-leaving-león" title="Link target outside of Sample">Chapter 11:   Leaving León</span></li>
<li id="toc-li-15"><span href="#/text/ch015#chapter-12-xaviers-contact-with-concrete" title="Link target outside of Sample">Chapter 12:   Xavier’s Contact with Concrete</span></li>
<li id="toc-li-16"><span href="#/text/ch016#chapter-13-police-ambush-in-sarria" title="Link target outside of Sample">Chapter 13:   Police Ambush in Sarria</span></li>
<li id="toc-li-17"><span href="#/text/ch017#chapter-14-pulpo-in-melide" title="Link target outside of Sample">Chapter 14:   Pulpo in Melide</span></li>
<li id="toc-li-18"><span href="#/text/ch018#chapter-15-santiago-de-compostela" title="Link target outside of Sample">Chapter 15:   Santiago de Compostela</span></li>
<li id="toc-li-19"><span href="#/text/ch019#chapter-16-mrs-red-cape" title="Link target outside of Sample">Chapter 16:   Mrs Red Cape</span></li>
<li id="toc-li-20"><span href="#/text/ch020#chapter-17-finally-finisterre" title="Link target outside of Sample">Chapter 17:   Finally Finisterre</span>
</li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?eef3a3d0